export enum IlmoittautuminenEnum {
  LisaaminenOnnistui = 1,
  LisaaminenEpaonnistui,
  PoistaminenOnnistui,
  PoistaminenEpaonnistui,
  MuokkaaminenOnnistui,
  MuokkaaminenEpaonnistui,
}
